import React from 'react';
import { AppBar, Toolbar, Typography, Button, Grid, Card, CardContent, Container } from '@mui/material';




const mockData = [
  {
    title: "Tutorials",
    description: "Learn about server configs, system optimization, and more!",
    buttonText: "Explore"
  },
  {
    title: "Web Services",
    description: "Find handy tools like our online guitar tuner, and more!",
    buttonText: "Discover"
  },
  {
    title: "Tech News",
    description: "Stay up-to-date with the latest in the tech world!",
    buttonText: "Read More"
  }
];

function Home() {
  return (

    <>
      hello world
    </>

  );
}

export default Home;
